import { useTranslation } from 'react-i18next';

export const CompanyInfo = ({ formData, onChange, onNext }) => {
    const { t } = useTranslation();
    return (
        <div className="w-full">
            <h2 className="text-2xl font-bold mb-6">{t('companyInfoSetup.title')}</h2>
            <p className="mb-6 text-gray-600">{t('companyInfoSetup.subtitle')}</p>

            <div className="mb-4">
                <label className="block text-gray-700 mb-2">{t('companyInfoSetup.companyName')}</label>
                <input
                    type="text"
                    placeholder="Ex: Payor"
                    value={formData.companyName}
                    onChange={(e) => onChange('companyName', e.target.value)}
                    className="input input-bordered w-full px-4 py-2 rounded"
                    required
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">{t('companyInfoSetup.legalForm')}</label>
                    <input
                        type="text"
                        placeholder="Ex: SARL"
                        value={formData.legalForm}
                        onChange={(e) => onChange('legalForm', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">{t('companyInfoSetup.companyId')}</label>
                    <input
                        type="text"
                        placeholder="NINEA"
                        value={formData.companyId}
                        onChange={(e) => onChange('companyId', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">{t('companyInfoSetup.companyAddress')}</label>
                    <input
                        type="text"
                        placeholder="adresse"
                        value={formData.companyAddress}
                        onChange={(e) => onChange('companyAddress', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">{t('companyInfoSetup.city')}</label>
                    <input
                        type="text"
                        placeholder="Dakar"
                        value={formData.city}
                        onChange={(e) => onChange('city', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div>
                    <label className="block text-gray-700 mb-2">{t('companyInfoSetup.sector')}</label>
                    <select
                        value={formData.sector}
                        onChange={(e) => onChange('sector', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    >
                        <option value="">{t('companyInfoSetup.selectSector')}</option>
                        <option value="Santé">{t('companyInfoSetup.sectorHealth')}</option>
                        <option value="Education">{t('companyInfoSetup.sectorEducation')}</option>
                        <option value="Finance">{t('companyInfoSetup.sectorFinance')}</option>
                        <option value="Commerce">{t('companyInfoSetup.sectorCommerce')}</option>
                        <option value="Technologie">{t('companyInfoSetup.sectorTechnology')}</option>
                    </select>
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">{t('companyInfoSetup.hourlyRate')}</label>
                    <select
                        value={formData.hourlyRate}
                        onChange={(e) => onChange('hourlyRate', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    >
                        <option value="">{t('companyInfoSetup.selectRate')}</option>
                        <option value="40">40</option>
                        <option value="35">42</option>
                    </select>
                </div>
            </div>

            <div className="mb-6">
                <label className="flex items-center">
                    <input
                        type="checkbox"
                        checked={formData.termsAccepted}
                        onChange={(e) => onChange('termsAccepted', e.target.checked)}
                        className="mr-2"
                    />
                    <span>{t('companyInfoSetup.confirmInfoAccurate')}</span>
                </label>
            </div>

            <div className="border rounded-lg p-6 mb-6 bg-gray-50">
                <h3 className="font-semibold mb-2">{t('companyInfoSetup.alreadyHaveAccount')}</h3>
                <p className="text-gray-600 mb-2">{t('companyInfoSetup.alreadyUseYros')}</p>
                <a href="/" className="text-[--color-primary] font-medium">{t('companyInfoSetup.logIn')}</a>
            </div>
        </div>
    );
};